import React, { useContext, useEffect, useState } from "react";
import { putData, postData } from "../../lib/utils";
import { Context } from "../contexts/AppContext";
import { useParams } from "react-router-dom";

const ChapterForm = (props) => {
  const { galleryId } = useParams();
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const [titles, setTitles] = useState({});
  const [chapterTimes, setChapterTimes] = useState({});

  // Load initial values from props.chapterArr
  useEffect(() => {
    if (props.chapterArr?.length > 0) {
      setTitles((prevTitles) => {
        const newTitles = { ...prevTitles };
        props.chapterArr.forEach((item) => {
          if (!newTitles[item._id]) {
            newTitles[item._id] = item.title || "";
          }
        });
        return newTitles;
      });

      setChapterTimes((prevTimes) => {
        const newTimes = { ...prevTimes };
        props.chapterArr.forEach((item) => {
          if (!newTimes[item._id]) {
            const [h = "00", m = "00", s = "00"] =
              item?.cuePoint?.split(":") || [];
            newTimes[item._id] = { hours: h, minutes: m, seconds: s };
          }
        });
        return newTimes;
      });
    }
  }, [props.chapterArr]);

  // Title change handler
  const handleTitleChange = (e, chapterId) => {
    const newValue = e.target.value;

    setTitles((prev) => ({
      ...prev,
      [chapterId]: newValue,
    }));

    // Sync parent chapterArr
    props.setChapterArr((prev) =>
      prev.map((ch) =>
        ch._id === chapterId ? { ...ch, title: newValue } : ch
      )
    );
  };

  // Time change handler
  const handleTimeChange = (e, chapterId) => {
    const field = e.target.name;
    const value = e.target.value.padStart(2, "0");

    // Update local state
    setChapterTimes((prev) => ({
      ...prev,
      [chapterId]: {
        ...prev[chapterId],
        [field]: value,
      },
    }));

    // Sync parent chapterArr
    props.setChapterArr((prev) =>
      prev.map((ch) => {
        if (ch._id === chapterId) {
          const updatedTime = {
            ...chapterTimes[chapterId],
            [field]: value,
          };
          return {
            ...ch,
            cuePoint: `${updatedTime.hours || "00"}:${updatedTime.minutes || "00"}:${updatedTime.seconds || "00"}`,
          };
        }
        return ch;
      })
    );
  };

  // Individual chapter update
  const handleSubmit = async (e, chapterId) => {
    e.preventDefault();
    const formattedTime = props.currentTime || "00:00:00";

    const json = await putData(`chapters/updatechapters/${chapterId}`, {
      title: titles[chapterId],
      cuePoint: formattedTime,
    });

    if (json) {
      console.log("Chapter updated", json);
      const [h, m, s] = formattedTime.split(":");
      setChapterTimes((prev) => ({
        ...prev,
        [chapterId]: { hours: h, minutes: m, seconds: s },
      }));
    }
  };

  // Delete chapter
  const deleteChapter = async (chapterId) => {
    if (!window.confirm("Are you sure you want to delete this chapter?")) return;
    try {
      const res = await postData(`chapters/deleteChapter/${chapterId}`);
      if (res) {
        props.setChapterArr?.((prev) => prev.filter((c) => c._id !== chapterId));
        setTitles((prev) => {
          const copy = { ...prev };
          delete copy[chapterId];
          return copy;
        });
        setChapterTimes((prev) => {
          const copy = { ...prev };
          delete copy[chapterId];
          return copy;
        });
      }
    } catch (err) {
      console.error("Error deleting chapter:", err);
    }
  };

  return (
    <div className="chapter-form h-[250px]">
      {props.chapterArr?.length > 0 ? (
        props.chapterArr.map((item) => (
          <form
            key={item._id}
            data-chapterid={item._id}
            onSubmit={(e) => handleSubmit(e, item._id)}
          >
            <button type="button" className="preview-btn">
              Preview
            </button>

            <div className="input-group">
              <label className="text-xs">Title:</label>
              <input
                type="text"
                value={titles[item._id] || ""}
                onChange={(e) => handleTitleChange(e, item._id)}
                required
              />
            </div>

            <div className="time-inputs">
              <input
                type="number"
                name="hours"
                value={chapterTimes[item._id]?.hours || ""}
                onChange={(e) => handleTimeChange(e, item._id)}
                min="0"
                max="60"
              />
              <span>:</span>
              <input
                type="number"
                name="minutes"
                value={chapterTimes[item._id]?.minutes || ""}
                onChange={(e) => handleTimeChange(e, item._id)}
                min="0"
                max="60"
              />
              <span>:</span>
              <input
                type="number"
                name="seconds"
                value={chapterTimes[item._id]?.seconds || ""}
                onChange={(e) => handleTimeChange(e, item._id)}
                min="0"
                max="60"
              />
            </div>

            <div className="button-group">
           
              <button
                type="button"
                className="delete-btn"
                onClick={() => deleteChapter(item._id)}
              >
                Delete
              </button>
            </div>
            <div className="h-8"></div>
          </form>
        ))
      ) : (
        <div className="flex text-center items-center h-full">
          Play video to start adding chapters.
        </div>
      )}

      <style>{`
        .chapter-form { max-width: 400px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 5px; background: #f9f9f9; }
        .input-group { margin-bottom: 10px; }
        label { display: block; font-weight: bold; margin-bottom: 5px; }
        input { width: 100%; padding: 4px; margin-bottom: 10px; border: 1px solid #ccc; border-radius: 4px; }
        .time-inputs { display: flex; align-items: center; }
        .time-inputs input { width: 65px; text-align: center; }
        .time-inputs span { margin: 0 5px; font-weight: bold; }
        .button-group { display: flex; justify-content: space-between; }
        .update-btn { color: green; padding: 4px 15px; border: 1px solid; border-radius: 4px; cursor: pointer; }
        .delete-btn { border: 1px solid; color: red; padding: 4px 15px; border-radius: 4px; cursor: pointer; }
        .preview-btn { color: #B99B6B; padding: 8px 15px; border: 1px solid; border-radius: 4px; cursor: pointer; margin-bottom: 10px; }
      `}</style>
    </div>
  );
};

export default ChapterForm;
